import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6h16","key":"svg-0"}],["path",{"d":"M6 12h11","key":"svg-1"}],["path",{"d":"M9 18h2","key":"svg-2"}],["path",{"d":"M18.42 15.61c.195 -.195 .426 -.35 .681 -.455c.255 -.106 .528 -.16 .804 -.16c.276 0 .549 .054 .804 .16c.255 .106 .486 .26 .681 .455c.195 .195 .35 .427 .455 .681c.106 .255 .16 .528 .16 .804c0 .276 -.054 .549 -.16 .804c-.105 .255 -.26 .486 -.455 .681l-3.39 3.42h-3v-3l3.42 -3.39","key":"svg-3"}]]

const IconFilter2Edit = createReactComponent('outline', 'filter-2-edit', 'Filter2Edit', __iconNode);

export default IconFilter2Edit;